import request from "root/js/request";

export const getExpensesCrossMP = async ({ cabinet_id, marketplace, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/expense/",
    method: "get",
    params: {
      cabinet_id,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};

export const getExpenseCrossMPById = async ({ cabinet_id, marketplace, expense_id, ...rest }) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/${expense_id}/`,
    method: "get",
    params: {
      cabinet_id,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};

export const postCreateExpenseCrossMP = async ({
  cabinet_id,
  marketplace,
  description,
  amount,
  date_from,
  date_to,
  operating_date,
  group,
  nds,
  is_applied_all,
  is_recurring,
  mp_products,
  ...rest
}) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/`,
    method: "post",
    params: {
      cabinet_id,
    },
    data: {
      marketplace,
      description,
      amount,
      date_from,
      date_to,
      operating_date,
      group,
      nds,
      is_applied_all,
      is_recurring,
      mp_products,
      ...rest,
    },
  });
  return response;
};

export const putEditExpenseCrossMPById = async ({
  cabinet_id,
  expense_id,
  marketplace,
  description,
  amount,
  date_from,
  date_to,
  operating_date,
  group,
  nds,
  is_applied_all,
  is_recurring,
  mp_products,
  ...rest
}) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/${expense_id}/`,
    method: "put",
    params: {
      cabinet_id,
    },
    data: {
      marketplace,
      description,
      amount,
      date_from,
      date_to,
      operating_date,
      group,
      nds,
      is_applied_all,
      is_recurring,
      mp_products,
      ...rest,
    },
  });
  return response.data;
};

export const deleteExpenseCrossMPById = async ({ cabinet_id, expense_id, ...rest }) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/${expense_id}/`,
    method: "delete",
    params: {
      cabinet_id,
      ...rest,
    },
  });
  return response;
};
